import { CheckCircle } from "@mui/icons-material";
import { styled, Typography } from "@mui/material";
import React from "react";

export const CheckList = styled("ul")`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;
const StyledLi = styled("li")`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
export const CheckListItem = ({ label }: { label: React.ReactNode }) => {
  return (
    <StyledLi>
      <CheckCircle sx={{ color: "success.main" }} />
      <Typography textTransform="uppercase">{label}</Typography>
    </StyledLi>
  );
};
